import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useFinanceSave } from '../../hooks/queries/useFinance';
import { useSnackbar } from '../../hooks/useSnackbar';

export default function FinancePromptDefaultsDialog({
  open, askPrice, askPayment, grossValue, paymentName, paymentId, onFinish, suppressForToday,
  saveMutation, appointmentId, items
}) {
  const { showError } = useSnackbar();
  const [currentPage, setCurrentPage] = useState(askPrice ? 'price' : 'payment'); // 'price' ou 'payment'

  const handleYesPrice = async () => {
    try {
      await saveMutation.mutateAsync({
        id: appointmentId,
        payload: {
          grossValue,
          paymentId: null,
          items,
          promoteGrossValueAsDefault: true,
          linkPaymentToSchedule: false,
        }
      });
      if (askPayment) {
        setCurrentPage('payment');
      } else {
        onFinish();
      }
    } catch (err) {
      showError(err.message);
    }
  };

  const handleNoPrice = () => {
    suppressForToday('defaultPrice');
    if (askPayment) {
      setCurrentPage('payment');
    } else {
      onFinish();
    }
  };

  const handleYesPayment = async () => {
    try {
      await saveMutation.mutateAsync({
        id: appointmentId,
        payload: {
          grossValue,
          paymentId,
          items,
          promoteGrossValueAsDefault: false,
          linkPaymentToSchedule: true,
        }
      });
      onFinish();
    } catch (err) {
      showError(err.message);
    }
  };

  const handleNoPayment = () => {
    suppressForToday('paymentLink');
    onFinish();
  };

  if (!open) return null;

  const fmt = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v ?? 0);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      {currentPage === 'price' && askPrice ? (
        <>
          <DialogTitle>Salvar valor como padrão?</DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            <Typography variant="body2">
              O serviço ainda não tinha um valor padrão configurado nesta agenda.
              Deseja salvar <strong>{fmt(grossValue)}</strong> como padrão para os próximos atendimentos?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleNoPrice}>Não, só neste</Button>
            <Button variant="contained" onClick={handleYesPrice}>Sim, salvar padrão</Button>
          </DialogActions>
        </>
      ) : currentPage === 'payment' && askPayment ? (
        <>
          <DialogTitle>Vincular forma de pagamento?</DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            <Typography variant="body2">
              A forma de pagamento <strong>{paymentName}</strong> ainda não está vinculada a esta agenda.
              Deseja adicioná-la como uma opção padrão?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleNoPayment}>Não, só neste</Button>
            <Button variant="contained" onClick={handleYesPayment}>Sim, vincular</Button>
          </DialogActions>
        </>
      ) : null}
    </Dialog>
  );
}
